import { useCallback, useEffect } from 'react'
import { debounce } from 'lodash';

type DebounceOptions = {
  flushBeforeCancel: boolean
}

export const useDebouncedCallback = <T extends (...args: any[]) => any>(callback: T, delay: number, dependencies: any[] = [], options?: DebounceOptions) => {
  const result = useCallback(debounce(callback, delay), dependencies)

  useEffect(() => {
    return () => {
      if (options?.flushBeforeCancel === true) {
        result.flush()
      }
      result.cancel()
    }
  }, [result])

  return result
}
